import { render, staticRenderFns } from "./LegalCheckbox.vue?vue&type=template&id=11337c68&scoped=true&"
import script from "./LegalCheckbox.vue?vue&type=script&lang=js&"
export * from "./LegalCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LegalCheckbox.vue?vue&type=style&index=0&id=11337c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11337c68",
  null
  
)

export default component.exports